import { frontendURL } from '../../../helper/URLHelper';
import DpCode from './DpCode.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dp-code'),
      name: 'dp_code',
      component: DpCode,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
